var _toConsumableArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var StateMachine = require('javascript-state-machine');

var StateMachineHistory = require('javascript-state-machine/lib/history');

var _require = require('./enum'),
    digits = _require.digits,
    ops = _require.ops,
    END = _require.END;

var digitsKeys = Object.values(digits);
var opsKeys = Object.values(ops);
var CfsmBase = StateMachine.factory({
  init: digits.ZERO,
  transitions: [{
    name: 'toDigit',
    from: [].concat(_toConsumableArray(digitsKeys), _toConsumableArray(opsKeys)),
    to: function to(n) {
      return n;
    }
  }, {
    name: 'toOp',
    from: digitsKeys,
    to: function to(op) {
      return op;
    }
  }, {
    name: 'end',
    from: digitsKeys,
    to: END
  }, {
    name: 'reset',
    from: '*',
    to: digits.ZERO
  }],
  methods: {
    /*
    ...digitsKeys.reduce((acc, n) => { acc[`on${n}`] = () => console.log(n); return acc; }, {} ),
    ...opsKeys.reduce((acc, op) => { acc[`on${op}`] = () => console.log(op); return acc; }, {} )
    */
  },
  plugins: [new StateMachineHistory()],
  observeUnchangedState: true
});
module.exports = CfsmBase;